import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AboutSection.css";
import { RiArrowRightDoubleFill } from 'react-icons/ri';
import AOS from "aos";
import "aos/dist/aos.css";

const AboutSection = () => {
  const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false)

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: false,     // animation only once on scroll

    });
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }


    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return (

    <section id="section-overview">
       <div className="header"><h2 className="myabout1">About Us</h2></div>
      <div
        className="container"
        style={{ backgroundSize: "cover", backgroundRepeat: "no-repeat" }}
      >
        <div
          className="row g-2 justify-content-between align-items-center ab1-reverse"

          style={{ backgroundSize: "cover", backgroundRepeat: "no-repeat" }}
        >
          {/* Left Column */}
          <div
            className="paru col-lg-5" data-aos="fade-right"
            style={{ backgroundSize: "cover", backgroundRepeat: "no-repeat" }}
          >
            <div
              className=" ps-lg-3"
              style={{ backgroundSize: "cover", backgroundRepeat: "no-repeat" }}
            >
              <div>

                <button id="subtitle" className="btn btn-sm mb-2 details-btn" >About us</button>

                <h1
                  className="wow fadeInUp animated"
                  data-wow-delay=".4s"
                  style={{
                    visibility: "visible",
                    animationDelay: "0.4s",
                    animationName: "fadeInUp",
                    fontWeight: "700",

                  }}
                >
                Barsana- The Soul Of Spiritual India
                </h1>
              </div>

              <p
                className=" dilu wow fadeInUp animated"
                data-wow-delay=".6s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.6s",
                  animationName: "fadeInUp",
                }}
              >
               Barsana is a realm of profound spirituality, revered as the holy birthplace of Radha Rani and the very ground where celestial love took root. This sacred city stands testament to centuries-old tales of Radha and Krishna, their timeless, celestial romance steeped in every grain of its history. To live here is to reside amidst that eternal narrative. Now, Aanandam Valleey presents a unique and blessed opportunity to build your dream home and establish your legacy within this transcendent spiritual landscape.

              </p>

              <a className="btn-main" href="/about-us" data-aos="zoom-in" data-aos-delay="400">
                <span>Read more</span>
                <RiArrowRightDoubleFill className="arrow-icon" />
              </a>
            </div>
          </div>

          {/* Right Column */}
          <div
            className="col-lg-6" data-aos="zoom-in"
            style={{ backgroundSize: "cover", backgroundRepeat: "no-repeat" }}
          >
            <img
              id="about-img-bottom"
              src={`${IMAGE_BASE_URL}/image3.png`}
              alt="Resort View"
              className="img-fluid "
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
